{
  "welcome": {
    "title": "Welcome to Baby Plan",
    "body": "Get to know the app in {{count}} short parts, about a minute each. Start with the main screen?",
    "start": "Start with Today",
    "all": "See all parts",
    "later": "Not now"
  },
  "step": "{{n}} of {{total}}",
  "tryBadge": "Try it",
  "skip": "Skip",
  "next": "Next",
  "back": "Back",
  "quiz": {
    "eyebrow": "Quick check",
    "label": "Answers",
    "right": "Right!",
    "wrong": "Not quite.",
    "continue": "Continue",
    "skip": "Skip"
  },
  "end": {
    "eyebrow": "{{done}} of {{total}} parts done",
    "title": "Nice work!",
    "next": "Next up: {{part}}, about {{count}} min.",
    "go": "Next: {{part}}",
    "all": "All parts",
    "close": "Back to the app",
    "allTitle": "You know Baby Plan!",
    "allBody": "All {{count}} parts done. Every part stays in Family › Learn the app."
  },
  "hint": {
    "label": "Guide",
    "text": "New here? A {{count}}-minute tour of {{part}}",
    "go": "Show me",
    "close": "Hide this hint"
  },
  "hub": {
    "title": "Learn the app",
    "lead": "{{count}} short parts. Each one opens a screen, points at everything there and ends with one quick question.",
    "progressLabel": "Your progress",
    "progress": "{{done}} of {{total}} parts done",
    "allDone": "All parts done",
    "checks": "{{right}} of {{total}} quick checks right",
    "checksNone": "No quick checks yet",
    "start": "Start",
    "continue": "Continue",
    "part": "Part {{n}}",
    "min_one": "{{count}} min",
    "min_other": "{{count}} min",
    "done": "Done",
    "notDone": "Not done yet",
    "quizRight": "Quick check passed",
    "quizWrong": "Quick check missed",
    "reset": "Start over"
  },
  "parts": {
    "today": {
      "title": "Today",
      "sub": "Soothe in one tap, the sleep timer",
      "steps": {
        "soothe": { "title": "One tap to soothe", "body": "The big button plays a calming sound for {{name}}. Tap again to pause." },
        "timer": { "title": "The sleep timer", "body": "Counts down to the next nap or bedtime, from {{name}}'s age and your logs. While {{name}} sleeps, it counts to the wake-up." },
        "pills": { "title": "Sound, timer, cry alert", "body": "Pick the sound and when it switches off. Cry alert listens for crying and starts the sound by itself." },
        "sleep": { "title": "Fell asleep? Woke up?", "body": "One tap starts or stops the sleep timer, and Undo is right there. In the evening this card walks you through the bedtime routine." },
        "family": { "title": "Family and settings", "body": "Tap {{name}} to invite a partner or nanny and to edit the routine and reminders." }
      },
      "quiz": {
        "q": "{{name}} just fell asleep in your arms. What do you tap?",
        "options": ["Start nap on the sleep card", "The big Play button", "Nothing: the app notices by itself"],
        "why": "The sleep card starts the sleep timer. The big button only plays the sound."
      }
    },
    "log": {
      "title": "Logging",
      "sub": "Feeds, diapers and sleep in a few taps",
      "steps": {
        "plus": { "title": "Log anything in seconds", "body": "Feeds, diapers, sleep, medicine: the + is on every tab." },
        "try": { "title": "Tap + and look around", "body": "It asks one question at a time, with big answers for one hand. Close it with × whenever you like." },
        "hint": { "title": "Hints that save a tap", "body": "When it's been a while since a feed or diaper, a hint shows up here. Tap it to log straight away." },
        "undo": { "title": "Made a mistake?", "body": "Every save shows Undo at the bottom for a few seconds. Later, tap the entry in Track to fix the time or delete it." }
      },
      "quiz": {
        "q": "You logged a diaper by mistake a second ago. What's the fastest fix?",
        "options": ["Log it again to cancel it", "Tap Undo at the bottom of the screen", "Nothing: logs can't be changed"],
        "why": "Undo shows for a few seconds after every save. After that, open the entry in Track."
      }
    },
    "track": {
      "title": "Track",
      "sub": "The day, the week and trends",
      "steps": {
        "since": { "title": "Since the last…", "body": "How long since the last feed, diaper and wake-up. Tap a tile to log that right away." },
        "strip": { "title": "Pick a day", "body": "Tap any day of the week. The arrows go to earlier weeks." },
        "summary": { "title": "The day in four numbers", "body": "Sleep, feeds, diapers, wake-up and bedtime, with what's usual for {{name}} under each." },
        "timeline": { "title": "Every entry of the day", "body": "Tap one to change its time or delete it. Everyone in the family sees the same list." },
        "more": { "title": "More to log", "body": "Pump, solids, growth, temperature and notes live here." },
        "views": { "title": "Tap Week", "body": "Day shows one day. Week shows seven side by side." },
        "week": { "title": "Seven days at a glance", "body": "One bar per day with the number on it. Switch between sleep, feeds and diapers. Tap a bar to open that day." },
        "usual": { "title": "A usual day", "body": "When {{name}} usually wakes up and goes to bed, how many naps and feeds: plain averages of the week." }
      },
      "quiz": {
        "q": "You logged a feed at the wrong time. How do you fix it?",
        "options": ["Log the feed again", "Wait: it fixes itself overnight", "Tap it in Track and change the time"],
        "why": "Tap any entry in Track to change its time or delete it."
      }
    },
    "sounds": {
      "title": "Sounds and cry alert",
      "sub": "Sounds, the sound timer, night mode",
      "steps": {
        "now": { "title": "Your sound", "body": "The sound the big button on Today plays. You can play it from here too." },
        "grid": { "title": "Pick a sound", "body": "Womb, noise, nature or lullaby: filter here, then tap any sound below to make it yours." },
        "timer": { "title": "Sound timer", "body": "The sound fades out by itself after the time you pick. Off keeps it playing." },
        "night": { "title": "Night mode: cry alert", "body": "The phone listens for crying and starts the sound by itself. Keep the screen on and the phone about 7 ft from the crib." }
      },
      "quiz": {
        "q": "What does cry alert need to work at night?",
        "options": ["The screen on and the phone near the crib", "The phone locked in another room", "A smart speaker"],
        "why": "The phone can only listen while the screen is on. It dims itself, and nothing is recorded or sent."
      }
    },
    "learn": {
      "title": "Learn",
      "sub": "What's normal now, the course, daily tips",
      "steps": {
        "phase": { "title": "Right now", "body": "What's typical at {{name}}'s age, and what's coming next." },
        "course": { "title": "Sleep course", "body": "Short lessons, a few minutes each. Pick up where you left off." },
        "tip": { "title": "Tip for today", "body": "A new tip for {{name}}'s age every day. Tap Ask about this to ask the chat." },
        "you": { "title": "For you", "body": "A five-second check-in on how you feel, and reads for parents." }
      },
      "quiz": {
        "q": "Where do you see what's typical for {{name}} this week?",
        "options": ["Track › Trends", "Learn, the Right now card", "Family"],
        "why": "The Right now card in Learn follows {{name}}'s age week by week."
      }
    },
    "chat": {
      "title": "Chat",
      "sub": "Ask anything, any hour",
      "steps": {
        "ask": { "title": "Ask anything, any hour", "body": "Sleep, feeding, growing up, how you're doing. Type a question here." },
        "prompts": { "title": "Not sure what to ask?", "body": "Start from one of these." },
        "knows": { "title": "Answers that fit {{name}}", "body": "The chat knows {{name}}'s age and the last 3 days of sleep and feeds." },
        "safety": { "title": "Not a doctor", "body": "For urgent symptoms, call your pediatrician or 911." }
      },
      "quiz": {
        "q": "{{name}} has a high fever and is hard to wake. What do you do?",
        "options": ["Call your pediatrician or 911 right away", "Ask the chat and wait for an answer", "Log it in Track and see tomorrow"],
        "why": "The chat helps with everyday questions. Urgent symptoms need a doctor now."
      }
    },
    "family": {
      "title": "Family and settings",
      "sub": "Invite your people, routine, reminders",
      "steps": {
        "babies": { "title": "Your babies", "body": "Tap a baby to switch. Twins or a sibling? Add a baby here." },
        "people": { "title": "Invite your people", "body": "A partner or nanny sees the same plan and log, free." },
        "plan": { "title": "{{name}}'s plan", "body": "The bedtime routine and sleep times. The sleep timer and reminders follow them." },
        "reminders": { "title": "Reminders", "body": "A gentle nudge before naps and bedtime." },
        "guide": { "title": "This guide", "body": "All parts and quick checks live here. Come back anytime." }
      },
      "quiz": {
        "q": "How does your partner see the same log on their phone?",
        "options": ["Share your password", "Send them screenshots", "Invite them in Family"],
        "why": "Invite them in Family. They sign in on their own phone and see the same plan and log, free."
      }
    }
  }
}
